import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiLinks } from '@cutting/app.api-links';
import { interval, Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';

@Injectable()
export class ActivateAccountBySmsCodeService {
  private timer: Observable<number>;
  private timeSec = 6 * 60;

  constructor(private http: HttpClient) {
    this.timer = interval(1000).pipe(
      map(() => this.timeSec--),
      share()
    );
  }

  getTimer(): Observable<number> {
    return this.timer;
  }

  resetTimer(): void {
    this.timeSec = 6 * 60;
  }

  activateClientBySmsCode(smsCode: number): Promise<void> {
    const searchParams: HttpParams = new HttpParams().set('smsCode', smsCode.toString());

    return new Promise((resolve, reject) => {
      this.http.post(ApiLinks.activateClientBySmsCode, undefined, { params: searchParams }).subscribe(() => {
        resolve(undefined);
      }, reject);
    });
  }

  resendSmsCode(clientId: number): Promise<void> {
    const searchParams: HttpParams = new HttpParams().set('clientId', clientId.toString());

    return new Promise((resolve, reject) => {
      this.http.post(ApiLinks.resendActivateSmsCode, undefined, { params: searchParams }).subscribe(() => {
        resolve(undefined);
      }, reject);
    });
  }
}
